// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CheckBoxArea_block__8EndR {
	display: flex;
	flex-direction: column;
	gap: 0.3rem;
	height: 2rem;
}

.CheckBoxArea_error__text__t9PUV {
	color: var(--red-color, #b3261e);
	font-family: 'Noto Sans';
	font-size: 0.75rem;
	font-style: normal;
	font-weight: 500;
	line-height: 160%; /* 1.2rem */
}

.CheckBoxArea_control__WCwtN {
	font-family: arial;
	display: block;
	position: relative;
	padding-left: 30px;
	margin-bottom: 5px;
	padding-top: 3px;
	cursor: pointer;
	font-size: 16px;
}
.CheckBoxArea_control__WCwtN input {
	position: absolute;
	z-index: -1;
	opacity: 0;
}
.CheckBoxArea_control_indicator__xh4dx {
	position: absolute;
	top: 0px;
	left: 0;
	height: 25px;
	width: 25px;
	background: #ffffff;
	border: 2px solid #875b52;
	border-radius: 3px;
}
.CheckBoxArea_control__WCwtN:hover input ~ .CheckBoxArea_control_indicator__xh4dx,
.CheckBoxArea_control__WCwtN input:focus ~ .CheckBoxArea_control_indicator__xh4dx {
	background: #ffffff;
}

.CheckBoxArea_control__WCwtN input:checked ~ .CheckBoxArea_control_indicator__xh4dx {
	background: #875b52;
}
.CheckBoxArea_control__WCwtN:hover input:not([disabled]):checked ~ .CheckBoxArea_control_indicator__xh4dx,
.CheckBoxArea_control__WCwtN input:checked:focus ~ .CheckBoxArea_control_indicator__xh4dx {
	background: #875b52;
}
.CheckBoxArea_control__WCwtN input:disabled ~ .CheckBoxArea_control_indicator__xh4dx {
	background: #e6e6e6;
	opacity: 0.6;
	pointer-events: none;
}
.CheckBoxArea_control_indicator__xh4dx:after {
	box-sizing: unset;
	content: '';
	position: absolute;
	display: none;
}
.CheckBoxArea_control__WCwtN input:checked ~ .CheckBoxArea_control_indicator__xh4dx:after {
	display: block;
}
.CheckBoxArea_control_checkbox__7ABBB .CheckBoxArea_control_indicator__xh4dx:after {
	left: 8px;
	top: 4px;
	width: 4px;
	height: 10px;
	border: solid #ffffff;
	border-width: 0 2px 2px 0;
	transform: rotate(45deg);
}
.CheckBoxArea_control_checkbox__7ABBB input:disabled ~ .CheckBoxArea_control_indicator__xh4dx:after {
	border-color: #7b7b7b;
}
`, "",{"version":3,"sources":["webpack://./src/Components/UI/CheckBoxArea/CheckBoxArea.module.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,sBAAsB;CACtB,WAAW;CACX,YAAY;AACb;;AAEA;CACC,gCAAgC;CAChC,wBAAwB;CACxB,kBAAkB;CAClB,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,WAAW;AAC/B;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,kBAAkB;CAClB,kBAAkB;CAClB,kBAAkB;CAClB,gBAAgB;CAChB,eAAe;CACf,eAAe;AAChB;AACA;CACC,kBAAkB;CAClB,WAAW;CACX,UAAU;AACX;AACA;CACC,kBAAkB;CAClB,QAAQ;CACR,OAAO;CACP,YAAY;CACZ,WAAW;CACX,mBAAmB;CACnB,yBAAyB;CACzB,kBAAkB;AACnB;AACA;;CAEC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;AACA;;CAEC,mBAAmB;AACpB;AACA;CACC,mBAAmB;CACnB,YAAY;CACZ,oBAAoB;AACrB;AACA;CACC,iBAAiB;CACjB,WAAW;CACX,kBAAkB;CAClB,aAAa;AACd;AACA;CACC,cAAc;AACf;AACA;CACC,SAAS;CACT,QAAQ;CACR,UAAU;CACV,YAAY;CACZ,qBAAqB;CACrB,yBAAyB;CACzB,wBAAwB;AACzB;AACA;CACC,qBAAqB;AACtB","sourcesContent":[".block {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 0.3rem;\n\theight: 2rem;\n}\n\n.error__text {\n\tcolor: var(--red-color, #b3261e);\n\tfont-family: 'Noto Sans';\n\tfont-size: 0.75rem;\n\tfont-style: normal;\n\tfont-weight: 500;\n\tline-height: 160%; /* 1.2rem */\n}\n\n.control {\n\tfont-family: arial;\n\tdisplay: block;\n\tposition: relative;\n\tpadding-left: 30px;\n\tmargin-bottom: 5px;\n\tpadding-top: 3px;\n\tcursor: pointer;\n\tfont-size: 16px;\n}\n.control input {\n\tposition: absolute;\n\tz-index: -1;\n\topacity: 0;\n}\n.control_indicator {\n\tposition: absolute;\n\ttop: 0px;\n\tleft: 0;\n\theight: 25px;\n\twidth: 25px;\n\tbackground: #ffffff;\n\tborder: 2px solid #875b52;\n\tborder-radius: 3px;\n}\n.control:hover input ~ .control_indicator,\n.control input:focus ~ .control_indicator {\n\tbackground: #ffffff;\n}\n\n.control input:checked ~ .control_indicator {\n\tbackground: #875b52;\n}\n.control:hover input:not([disabled]):checked ~ .control_indicator,\n.control input:checked:focus ~ .control_indicator {\n\tbackground: #875b52;\n}\n.control input:disabled ~ .control_indicator {\n\tbackground: #e6e6e6;\n\topacity: 0.6;\n\tpointer-events: none;\n}\n.control_indicator:after {\n\tbox-sizing: unset;\n\tcontent: '';\n\tposition: absolute;\n\tdisplay: none;\n}\n.control input:checked ~ .control_indicator:after {\n\tdisplay: block;\n}\n.control_checkbox .control_indicator:after {\n\tleft: 8px;\n\ttop: 4px;\n\twidth: 4px;\n\theight: 10px;\n\tborder: solid #ffffff;\n\tborder-width: 0 2px 2px 0;\n\ttransform: rotate(45deg);\n}\n.control_checkbox input:disabled ~ .control_indicator:after {\n\tborder-color: #7b7b7b;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"block": `CheckBoxArea_block__8EndR`,
	"error__text": `CheckBoxArea_error__text__t9PUV`,
	"control": `CheckBoxArea_control__WCwtN`,
	"control_indicator": `CheckBoxArea_control_indicator__xh4dx`,
	"control_checkbox": `CheckBoxArea_control_checkbox__7ABBB`
};
export default ___CSS_LOADER_EXPORT___;
